<template>
  
  <v-dialog 
    ref="dialog"
    v-model="open"
    persistent
    lazy
    full-width
    width="290px"
    :return-value.sync="date"
    :disabled="disabled"
  >
    
    <v-text-field 
      slot="activator" 
      v-model="date"
      :label="label"
      prepend-icon="event"
      readonly
    ></v-text-field>

    <v-date-picker 
      v-model="date"
      :min="min"
      :max="max"
      :type="type" @input="$refs.dialog.save(date)"
    ></v-date-picker>

  </v-dialog>

</template>

<script>

  export default {

    props: {
      value: {
        type: String,
        default: ''
      },
      min: {
        type: String,
        default: ''
      },
      max: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'date'
      },
      label: {
        type: String,
        default: 'Select Date'
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },

    data () {
      return {
        open: false,
        date: this.value,
      }
    },

    watch: {
      value(val) {
        if (val) {
          this.date = val
        }
      },
      date(val) {
        if (val) {
          this.$emit('input', val)
        }
      }
    },

  }

</script>
